// =====================================================================
// Z-Index Management System
// =====================================================================
// CRITICAL: NEVER use hardcoded z-index values in components.
// ALWAYS use these semantic constants to ensure consistent stacking order.
// See: docs/core/CODE-STYLE.md#7-z-index-management-stacking-order
// =====================================================================
// NOTE: These values MUST stay in sync with src/styles/variables/z-index.scss
// =====================================================================

// --------------- Z-Index Scale (Private Constants) ---------------
const Z_INDEX_SUB = -1;
const Z_INDEX_0 = 0;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Z_INDEX_BUMP = 1;
const Z_INDEX_1 = 100;
const Z_INDEX_2 = 200;
const Z_INDEX_3 = 300;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Z_INDEX_4 = 400;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Z_INDEX_5 = 500;
const Z_INDEX_6 = 600;
const Z_INDEX_7 = 700;
const Z_INDEX_8 = 800;
const Z_INDEX_9 = 900;
const Z_INDEX_10 = 1000;
const Z_INDEX_11 = 1100;

// ------------ Z-Index Applications (Public API) ------------
// ------------- ordered by priority from top to bottom ------------
export const zIndex = {
  locationPickerScreen: Z_INDEX_11,
  termsOfUse: Z_INDEX_11,
  chatWidget: Z_INDEX_10,
  learnMoreForm: Z_INDEX_10,
  modalDialog: Z_INDEX_9,
  panel: Z_INDEX_9,
  filters: Z_INDEX_9,
  appBanner: Z_INDEX_8,
  dropdown: Z_INDEX_8,
  fullScreenBackground: Z_INDEX_8,
  brushStroke: Z_INDEX_8,
  fixedFooter: Z_INDEX_7,
  header: Z_INDEX_7,
  expHeaderText: Z_INDEX_7 + Z_INDEX_SUB,
  signInOverlay: Z_INDEX_6,
  mapHeader: Z_INDEX_3,
  mapPanel: Z_INDEX_2,
  close: Z_INDEX_1,
  pvrButton: Z_INDEX_1,
  stickyTabBar: Z_INDEX_1 + Z_INDEX_SUB, // 99 - below PVR buttons
  fullMapButton: Z_INDEX_1 + (Z_INDEX_SUB * 10), // 90 - below sticky tab bar
  listingPopover: Z_INDEX_1,
  homeModuleSwiper: Z_INDEX_0,
} as const;

export type ZIndex = typeof zIndex;
